/**
 * Collection list — Swiper init for split (Figma) carousel.
 * Requires global Swiper from swiper.min.js (load before this file).
 */
(function () {
  function getCarouselCols(containerRoot) {
    if (!containerRoot || containerRoot === document) {
      return document.querySelectorAll('.cc-collection-list__carousel-col');
    }
    if (containerRoot.classList && containerRoot.classList.contains('cc-collection-list__carousel-col')) {
      return [containerRoot];
    }
    return containerRoot.querySelectorAll('.cc-collection-list__carousel-col');
  }

  function initSwipers(containerRoot) {
    if (typeof Swiper === 'undefined') return;

    getCarouselCols(containerRoot).forEach(function (col) {
      var el = col.querySelector('.cc-collection-list__swiper');
      if (!el) return;
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }
      var prev = col.querySelector('[data-cc-cl-prev]');
      var next = col.querySelector('[data-cc-cl-next]');
      if (!prev || !next) return;

      /* global Swiper */
      /* lockClass defaults to swiper-button-lock; swiper.min.css uses display:none — use custom class */
      var swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        watchOverflow: true,
        watchSlidesProgress: true,
        observer: true,
        roundLengths: true,
        observeParents: true,
        rtl: document.documentElement.getAttribute('dir') === 'rtl',
        navigation: {
          prevEl: prev,
          nextEl: next,
          disabledClass: 'cc-cl-swiper-btn--disabled',
          lockClass: 'cc-cl-nav-lock',
        },
      });

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          swiper.update();
        });
      });
    });
  }

  function updateAllSplitSwipers() {
    document.querySelectorAll('.cc-collection-list__swiper.swiper-container').forEach(function (node) {
      if (node.swiper) {
        node.swiper.update();
      }
    });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAllSplitSwipers, 120);
  }

  function destroySwipers(containerRoot) {
    getCarouselCols(containerRoot).forEach(function (col) {
      var el = col.querySelector('.cc-collection-list__swiper');
      if (el && el.swiper) {
        el.swiper.destroy(true, true);
      }
    });
  }

  function onReady() {
    initSwipers(document);
  }

  if (!window.__ccCollectionListSwiperBoot) {
    window.__ccCollectionListSwiperBoot = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady, { once: true });
    } else {
      onReady();
    }
    window.addEventListener('resize', onResize);
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector('.cc-collection-list__swiper')) {
        initSwipers(event.target);
        requestAnimationFrame(function () {
          updateAllSplitSwipers();
        });
      }
    });
    document.addEventListener('shopify:section:unload', function (event) {
      destroySwipers(event.target);
    });
  }
})();
